import { Translate, TranslateProps } from 'react-localize-redux';
import { Typography, TypographyProps } from '.';

type I18nTypographyProps = TypographyProps &
  TranslateProps & {
    id: string;
    as?: React.ElementType;
  };

function I18nTypography({
  id,
  data,
  margin = '0',
  ...rest
}: I18nTypographyProps) {
  return (
    <Typography margin={margin} {...rest}>
      <Translate id={id} data={data} />
    </Typography>
  );
}

export { I18nTypography };
